import { register } from 'async-ops';
import { getDefaultOptions, throwExceptionErrors } from '../../../utils/fetch';
import { callMdaePublicApi } from "../../../call-web-api";
import mdaeNotfy, { NOTIFY_MESSAGE_TYPE } from "../../../common_components/common_widgets/toast/notify";

export const EDIT_DOCUMENT = 'EDIT_DOCUMENT';

export const service = async (data) => {

  const response: any = await callMdaePublicApi({
    type: 'post',
    contentType: 'application/json',
    url: '/Api/Document/EditDocument',
    isRoutedApiCall: true,
    ...getDefaultOptions(),
    body: JSON.stringify(data)
  })
  throwExceptionErrors(response);
  if (response && response.isEdited) {
    mdaeNotfy({ message: data.documentName + " Edited Succesfully!", messageType: NOTIFY_MESSAGE_TYPE.SUCCESS })
  }
  return response;
};

const mockData = () => {
  return ([])
};

const mock = () => Promise.resolve(mockData());

register(EDIT_DOCUMENT, service, mock);
